import { useCallback } from 'react';

import { useUrlState } from '@/shared/lib/hooks';

import { MAP_GROUP_BY, type MapGroupBy } from './types';

const DEFAULT_GROUPING_URL_STATE = { groupBy: 'location' };

const isGroupBy = (value: string): value is MapGroupBy => (MAP_GROUP_BY as readonly string[]).includes(value);

export function useMapGrouping() {
  const [urlState, setUrlState] = useUrlState(DEFAULT_GROUPING_URL_STATE);

  return {
    groupBy: isGroupBy(urlState.groupBy) ? urlState.groupBy : 'location',
    setGroupBy: useCallback((groupBy: MapGroupBy) => setUrlState({ groupBy }), [setUrlState])
  };
}
